
import { computed, defineComponent, inject, onMounted } from 'vue'
import BaseInputText from '@/core/components/base/BaseInputText.vue'
import BaseSelect from '@/core/components/base/BaseSelect.vue'
import InterfaceFilterVideosData from '@/assets/ts/_utils/models/FilterVideosData'

export default defineComponent({
  name: 'videos-filter',
  components: {
    BaseSelect,
    BaseInputText,
  },
  props: {
    pagesTotal: {
      default: 0,
      type: Number,
      required: true,
    },
    itemsTotal: {
      default: 0,
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const videosFilterData = inject(
      'videosFilterData'
    ) as InterfaceFilterVideosData

    const filterVideosButtonClick = () => {
      context.emit('filterVideosButtonClick', true)
    }

    const resetFilterForm = () => {
      for (const item in videosFilterData) {
        if (item !== 'page' && item !== 'limit') {
          videosFilterData[item] = null
        }
      }
      context.emit('filterVideosButtonClick')
    }

    const showPagination = computed(() => {
      return props.pagesTotal > 1
    })

    const paginationClick = val => {
      videosFilterData.page = val
      context.emit('filterVideosButtonClick')
    }

    const parseParamsFromUrl = () => {
      const searchString = window.location.search.replace('?', '')
      const urlSearchParams = new URLSearchParams(searchString)
      return Array.from(urlSearchParams)
    }

    const setDefaultFilterData = () => {
      videosFilterData.page = 1
      videosFilterData.limit = 10
      videosFilterData['filter[status]'] = 'not_verified'
    }

    const convertParamsFromURLArrayToObject = array => {
      array.forEach(([key, value]) => {
        if (key === 'filter[rubric_id]') {
          videosFilterData[key] = value.split(',').map(Number)
        } else if (key === 'filter[user_id]' || key === 'filter[id]') {
          videosFilterData[key] = value.split(',')
        } else {
          if (value === 'true') {
            videosFilterData[key] = true
          } else {
            videosFilterData[key] = value
          }
        }
      })
    }

    onMounted(async () => {
      const parsedURLArray = parseParamsFromUrl()
      if (parsedURLArray.length) {
        convertParamsFromURLArrayToObject(parsedURLArray)
      } else {
        setDefaultFilterData()
      }
      context.emit('filterVideosButtonClick')
    })

    return {
      showPagination,
      paginationClick,
      videosFilterData,
      filterVideosButtonClick,
      parseParamsFromUrl,
      resetFilterForm,
    }
  },
})
